/**
 * Shared viewport breakpoint definitions for Wand apps.
 * Use these consistently across viewport detection, media queries, and Panda conditions
 * to avoid disconnects when resizing between mobile, compact, and desktop layouts.
 */
export const BREAKPOINTS = {
    /** Viewport width at which we consider it "mobile" (drawer, bottom sheet, mobile pane) */
    mobile: 768,
    /** Max height for "small window" detection - tablet width + this height = treated as mobile */
    maxHeightSmallWindow: 600,
    /** Viewport width for tablet/small window detection */
    tablet: 1024,
    /** Viewport width at which layout goes compact (narrow sidebar, single column, etc.) */
    compact: 1119,
} as const;

/** Media query strings for matchMedia (no @media prefix) */
export const MEDIA_QUERIES = {
    mobile: `(max-width: ${BREAKPOINTS.mobile}px)` as const,
    mobileUp: `(min-width: ${BREAKPOINTS.mobile + 1}px)` as const,
    compact: `(max-width: ${BREAKPOINTS.compact}px)` as const,
    compactUp: `(min-width: ${BREAKPOINTS.compact + 1}px)` as const,
    /** Compact but not mobile - e.g. narrow desktop window */
    compactOnly: `(min-width: ${BREAKPOINTS.mobile + 1}px) and (max-width: ${BREAKPOINTS.compact}px)` as const,
} as const;
